import React from "react";
import OthersHero from "./OthersHero";

const GalleryHero = () => {
  return (
    <div className="about-hero-wrapper h-75">
      <OthersHero otherheading="Gallery" />
    </div>
  );
};

export default GalleryHero;
